import { render, staticRenderFns } from "./TripDetails.vue?vue&type=template&id=218b5ea8&scoped=true&"
import script from "./TripDetails.vue?vue&type=script&lang=js&"
export * from "./TripDetails.vue?vue&type=script&lang=js&"
import style0 from "./TripDetails.vue?vue&type=style&index=0&id=218b5ea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218b5ea8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('218b5ea8')) {
      api.createRecord('218b5ea8', component.options)
    } else {
      api.reload('218b5ea8', component.options)
    }
    module.hot.accept("./TripDetails.vue?vue&type=template&id=218b5ea8&scoped=true&", function () {
      api.rerender('218b5ea8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Trips/TripDetails.vue"
export default component.exports